export enum CoverageAssistantGridField {
  MATERIAL = 'commodityId',
  UNDERCOVERED_QUANTITY = 'undercoveredQuantity',
  UNIT = 'unitId',
  PRICE_UNIT = 'priceUnit',
  TIMEFRAME = 'timeframe',
  CURRENCY = 'currency',
  BASELINE_PRICE_PER_PRICE_UNIT = 'baselinePricePerPriceUnit',
  QUALIFIED_SUPPLIERS = 'qualifiedSuppliers',
  ORGANIZATION = 'organization',
}

export interface CoveragePredictionRow {
  rowId: string;
  commodityId: string;
  commodityGroupId?: string | null;
  organizationId: string;
  undercoveredQuantity: number;
  unitId: string;
  priceUnit: number;
  validFrom: string;
  validTo: string;
  currency: string;
  minimumOrderQuantity: number;
  qualifiedSupplierIds: string[];
  title?: string;
  description?: string;
  baselinePricePerPriceUnit?: number;
  selected?: boolean;
}
